import DataTable from "react-data-table-component";
import { Card, CardBody, Col } from "reactstrap";
import JavaScriptSourcedDataHeader from "./JavaScriptSourcedData";
import { AJAX_SOURCE_COLUMN, JAVASCRIPT_SOURCE_DATA } from "../../../../Data/DataTable/DataSourceData";

const JavaScriptSourcedData = () => {
  return (
    <Col sm="12">
      <Card>
       <JavaScriptSourcedDataHeader />
        <CardBody>
          <div className="table-responsive">
            <DataTable data={JAVASCRIPT_SOURCE_DATA} columns={AJAX_SOURCE_COLUMN} striped highlightOnHover pagination/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default JavaScriptSourcedData;
